import {
  Box,
  LinearProgress,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import styles from "../../styles/Common.module.css";

import CloseIcon from "@mui/icons-material/Close";
import { useRouter } from "next/router";
import ComingSoonModal from "./ComingSoonModal";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { getCookie } from "../utils/cookie";
import { useDispatch } from "react-redux";
import { updateProductCount } from "../../redux/fetcher/TarrotCardSlice";

const TarrotDetailsModal = ({
  openDetailsModal,
  setOpenDetailsModal,
  shopDetails,
}) => {

  const dispatch = useDispatch()
  console.log("shopDetails", shopDetails);
  const handleNewClose = async () => {
    setLoaderOpen(true)

  let obj = {
    searchcondition: {
      user_id: getCookie("guest_id"),
    },
    sort: {
      type: "asc",
      field: "priority",
    },
  };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...obj }),
  };
  let rep = await fetch(
    `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
    requestOptions
  );
  rep = await rep.json();
  console.log("rep============>", rep);
  if(rep.status == 'success') {
    const count = rep.results.res?.reduce(
      (accumulator, currentValue) => accumulator + currentValue.quantity,
      0
    );
    localStorage.setItem('cartCount', parseInt(count));
    dispatch(updateProductCount(parseInt(count)))
  }
  setOpenDetailsModal(false);
  setLoaderOpen(false)
  };
  const router = useRouter();

  const [copyRightOpen, setCopyRightOpen] = useState(false);
  const copyRightMOdal = () => {
    setCopyRightOpen(true);
  };

  const [image, setImage] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");
  const [outofstockText, setOutofstockText] = useState("");
  const [isOutOfStock, setIsOutOfStock] = useState(false);


  useEffect(() => {
    const imageWithStatusTrue = shopDetails.product_details.image.find((img) =>
      img.flds.find((fld) => fld.key === "img_status" && fld.value === true)
    );

    const imageUrl = `${process.env.NEXT_PUBLIC_IMG_URL3}${imageWithStatusTrue?.baseurl}${imageWithStatusTrue?.fileservername}`;

    if (imageWithStatusTrue) {
      setImage(imageUrl);
      setActiveIndex(
        shopDetails.product_details.image.indexOf(imageWithStatusTrue)
      );
    }
  }, [shopDetails.product_details.image]);

  

  useEffect(() => {
    if (shopDetails.quantity == 0) {
      setQuantity(1);
    } else {
      setQuantity(shopDetails.quantity);
    }
  }, [shopDetails]);

  const processImages = (images) => {
    if (!images || images.length === 0) return [];

    const imageWithStatus = images.find(
      (img) =>
        img.imgfields &&
        img.imgfields.some(
          (field) => field.key === "img_status" && field.value === true
        )
    );

    const otherImages = images.filter(
      (img) =>
        !(
          img.imgfields &&
          img.imgfields.some(
            (field) => field.key === "img_status" && field.value === true
          )
        )
    );

    if (imageWithStatus) {
      return [imageWithStatus, ...otherImages];
    } else {
      return images;
    }
  };

  const images = processImages(shopDetails.product_details.image);

  const showImage = (imgUrl, index) => {
    setImage(imgUrl);
    setActiveIndex(index);
  };

  const productQuantity = async (type) => {
    let updatedQuantity = quantity;

    if (type == "add") {
      updatedQuantity = quantity + 1;
      setQuantity(updatedQuantity);
    } else if (type == "remove") {
      if (quantity > 1) {
        updatedQuantity = quantity - 1;
        setQuantity(updatedQuantity);
      }
    }

    await addToCart(false, updatedQuantity);
  };

  const addToCart = async (isBuyNow, updatedQuantity) => {
    setLoaderOpen(true);

    let payload = {
      product_id: shopDetails.product_details._id,
      quantity: updatedQuantity,
      user_id: getCookie("guest_id"),
      fromCartpage: true,
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };

    let resp = await fetch(
      `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/add-update-cart`,
      requestOptions
    );

    resp = await resp.json();

    if (resp && resp.status == "success") {
      // setSnackbarState(true);
      // setSnackMsg("Product Added to Cart");
      setLoaderOpen(false);
      if (isBuyNow) {
        setOpenDetailsModal(false);
        router.push("/shop/cart");
      }
    } else {
      if (resp.message == "Out of Stock") {
        setIsOutOfStock(true)
        setOutofstockText("Sold Out");
        setLoaderOpen(false);
      } else {
        setSnackMsg("Something went wrong !!");
        setLoaderOpen(false);
      }
    }
  };

  const closeSnack = () => {
    setSnackbarState(false);
  };

  const goToCart = () => {
    setOpenDetailsModal(false);
    router.push("/shop/cart")
  };

  return (
    <>
      <Modal
        open={openDetailsModal}
        onClose={handleNewClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main banner_modal_main_new banner_modal_main_new1 shop_details_modal"
      >
        <div className="main_wrpr_finddivine">
          <span className="close_btn" onClick={handleNewClose}>
            <CloseIcon />
          </span>
          <Box className="banner_modal_box_new banner_modal_box_neww">
            <Typography
              id="modal-modal-description" component="div"
              // sx={{ mt: 2 }}
              // className="modal_banner_new"
            >
              <div className="sub_modal_banner_new">
                <div className="mdl_hdr">
                  <h2>Details of {shopDetails.product_details.name}</h2>
                </div>
                {/* {loader && <LinearProgress />} */}
                <div className={styles.tarrotcardposter_detailswrapper}>
                  <div className={styles.tarrotcardposter_imgsec}>
                    {/* <div className={styles.tarrotcardposter_imgwrap}> */}
                    <div className={styles.tarrotcardposter_imginnerwrap}>
                      <img src={image} alt="" />
                    </div>
                    {images && images.length > 1 ? (
                      <ul className={styles.tarrotcardposter_imgcarousel}>
                        <span
                          className={`${styles.tarrotcardposter_carousel} ${styles.tarrotcardposter_imgprev}`}
                        >
                          <svg
                            width="8"
                            height="15"
                            viewBox="0 0 16 27"
                            xmlns="http://www.w3.org/2000/svg"
                            className="ZpyMwK"
                          >
                            <path
                              d="M16 23.207L6.11 13.161 16 3.093 12.955 0 0 13.161l12.955 13.161z"
                              fill="#000"
                              className=""
                            ></path>
                          </svg>
                        </span>
                        {images.map((img, index) => {
                          const imgConcatedUrl = `${process.env.NEXT_PUBLIC_IMG_URL3}${img.baseurl}${img.fileservername}`;
                          return (
                            <li key={index}>
                              <div
                                className={`${styles.image_box} ${
                                  index === activeIndex ? styles.active : ""
                                }`}
                                onClick={() => showImage(imgConcatedUrl, index)}
                              >
                                <img src={imgConcatedUrl} alt="" />
                              </div>
                            </li>
                          );
                        })}
                        <span
                          className={`${styles.tarrotcardposter_carousel} ${styles.tarrotcardposter_imgnext}`}
                        >
                          <svg
                            width="8"
                            height="15"
                            viewBox="0 0 16 27"
                            xmlns="http://www.w3.org/2000/svg"
                            className="ZpyMwK"
                          >
                            <path
                              d="M16 23.207L6.11 13.161 16 3.093 12.955 0 0 13.161l12.955 13.161z"
                              fill="#000"
                              className=""
                            ></path>
                          </svg>
                        </span>
                      </ul>
                    ) : null}
                    {/* </div> */}
                  </div>

                  <div className={styles.tarrotcardposter_detailssec}>
                    <div className={styles.content_part}>
                      <h2>{shopDetails.product_details.name}</h2>
                      <h3>{shopDetails.product_details.description}</h3>
                      <div className={styles.price_section}>
                        <h4>Price:</h4>
                        <h4>
                          <strong>${shopDetails.product_details.mrp}</strong>
                        </h4>
                      </div>
                      {!isOutOfStock && <div className={styles.cart_itemcontent_lowerleft}>
                        <h5>Qty:</h5>
                        <div className={styles.cart_item_incdec}>
                          <button
                            onClick={() => {
                              productQuantity("remove");
                            }}
                            disabled={quantity <= 1}
                          >
                            <RemoveIcon />
                          </button>
                          <span>{quantity}</span>
                          <button
                            onClick={() => {
                              productQuantity("add");
                            }}
                          >
                            <AddIcon />
                          </button>
                        </div>
                        {/* <h5 className={styles.cart_greytext}>$19.99</h5> */}
                      </div>}
                      {isOutOfStock && (
                        <h5 className={styles.cart_itemcontent_lowerright}>
                          {outofstockText}
                        </h5>
                      )}
                    </div>

                    <div className={styles.tarrotcardposter_cartbtn}>
                      {!isOutOfStock ? <button onClick={() => addToCart(true, quantity)}>
                        Buy Now
                      </button> : <button onClick={() => goToCart()}>
                        Go To Cart
                      </button>}
                    </div>
                  </div>
                </div>
              </div>
            </Typography>
          </Box>
        </div>
      </Modal>

      {copyRightOpen ? (
        <ComingSoonModal
          copyRightOpen={copyRightOpen}
          setCopyRightOpen={setCopyRightOpen}
        />
      ) : (
        ""
      )}

      <Modal
        open={loaderOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="linear_loader_modalbox">
          <LinearProgress />
        </Box>
      </Modal>

      <Snackbar
        open={snackbarState}
        autoHideDuration={3000}
        onClose={() => closeSnack()}
        className="snackbarClass"
        message={snackMsg}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        bodyStyle={{ backgroundColor: "teal", color: "coral" }}
      />
    </>
  );
};

export default TarrotDetailsModal;
